module.exports = __webpack_public_path__ + "static/media/ngt-icon.f9213743.svg";